import React from "react";
import SuppliersModule from "../../suppliers/SuppliersModule";

/* Staff suppliers view — thin wrapper around the main-workspace
   SuppliersModule, locked to read-only. Staff get the same directory
   layout, search, filters, and detail sheet that owners use, minus the
   add / edit / delete / upload affordances. The readOnly prop collapses
   every mutation permission in one place (canAdd / canEdit / canManage)
   so the FAB, row action buttons, and create modal are all suppressed
   from a single flag. */
export default function SuppliersPanel({state,dispatch,t,platformCtx}){
  return <SuppliersModule state={state} dispatch={dispatch} t={t} platformCtx={platformCtx} readOnly/>;
}
